//import Alpine from 'alpinejs'
//Alpine.start()

//console.debug('hello!');

/*
 * Example: Conditionally imports './splide' file if an element with
 * '.splide-block' class exists, optimizing load performance.
 */

// if (document.querySelector('.splide-block')) {
//     import('./splide').then(function (page) {
//         page.initSplide();
//     });
// }

import { initNav } from './navigation';
initNav();

if (document.getElementsByClassName('contact-block').length != 0) {
    import('./contact').then(function (page) {
        page.initContact();
    });
}
if (document.getElementsByClassName('accordion-block').length != 0 || document.getElementsByClassName('career-block').length != 0) {
    import('./accordion').then(function (page) {
        page.initAccordion();
    });
}
if (document.getElementsByClassName('image-slider-block').length != 0) {
    import('./splide').then(function (page) {
        page.initSplide();
    });
}

if (document.getElementsByClassName('case-images').length != 0) {
    import('./fancybox').then(function (page) {
        page.initFancybox();
    });
}
